const DoughnutSections = {
  PiPayment: {
    name: "PI Payment",
    color: "#962CF7",
  },
  PropertyTax: {
    name: "Property Tax",
    color: "#8CC2E9",
  },
  Insurance: {
    name: "Insurance",
    color: "#51DDAB",
  },
  PMI: {
    name: "PMI",
    color: "#0090F8",
  },
  HOA: {
    name: "HOA",
    color: "#F800DF",
  },
};

export default DoughnutSections;

export { DoughnutSections };
